import {useContext} from 'react';

import {useEntityOrganizationQuery} from '../../../generated/graphql';
import {AccountSelectorContext} from './AccountSelectorContextProvider';
import {useAccountList} from './useAccountList';

export function useAccountBasedOnUrl(entityName: string | undefined) {
  const {setSelectedAccount} = useContext(AccountSelectorContext);
  const {data: newOrg} = useEntityOrganizationQuery({
    variables: {teamName: entityName ?? ''},
    skip: !entityName,
  });
  const newOrgId = newOrg?.entity?.organization?.id;
  const usersAccounts = useAccountList();
  const newAccount = newOrgId
    ? usersAccounts.accountList.find(org => org.id === newOrgId)
    : null;
  if (newAccount) {
    setSelectedAccount(newAccount);
  }
}
